module.exports = __webpack_public_path__ + "static/media/cust-journey.58d440f2.png";